export const ANNOUNCEMENTS_CONFIG_PROP = {
  VIEW: "view",
  DESIGN_STYLE: "designStyle",
  LAYOUT_STRUCTURE: "layoutStructure",
  DISPLAY_NUMBER_OF_ITEMS: "displayNumberOfItems",
  COLUMNS: "columns",
  DATE_FORMAT: "dateFormat",
  BORDER_RADIUS: "borderRadius",
  DATE_IN_IMAGE: "dateInImage",
};

export const ANNOUNCEMENT_PROP = {
  IMAGE: "image",
  LINK: "url",
  NEW_TAB: "newTab",
  TITLE: "title",
  LINK_TEXT: "linkText",
  DATE: "date",
  TEXT: "text",
  TIME: "time",
  LOCATION: "location",
  COLOR: "color",
  TEXT_COLOR: "textColor",
  ICON: "icon",
  EMOJI: "emoji",
  EMOJI_ENABLED: "emojiEnabled",
  OVERLAY: "overlay",
};

export const LAYOUT_STRUCTURE_OPTIONS = {
  ICON: "icon",
  DATE: "date",
  TEXT: "text",
  LINK: "link",
  OVERLINE: "overline",
  ARROW: "arrow",
  LOCATION: "location",
  PARTICIPANTS: "participants",
  TIME: "time",
  ATTEND_BUTTON: "attend-button",
  DATE_IN_IMAGE: "dateInImage",
};

export const DESIGN_STYLES = {
  // new
  CLASSIC: "classic",
  BACKGROUND: "background",
  NOTIFICATION: "notification",
  // old
  ANNOUNCEMENT: "announcement",
  WEBINAR: "webinar",
  TEAM_EVENT: "team_event",
  NEWS: "news",
  EVENT: "event",
  SHORT_NEWS: "short_news",
  IMAGE: "image",
};

export const LAYOUT_OPTIONS_BASED_ON_DESIGN = {
  [DESIGN_STYLES.BACKGROUND]: [
    { prop: LAYOUT_STRUCTURE_OPTIONS.LINK, title: "link-text" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.ARROW, title: "arrow" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.DATE, title: "date" },
  ],
  [DESIGN_STYLES.CLASSIC]: [
    { prop: LAYOUT_STRUCTURE_OPTIONS.TEXT, title: "subtext" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.DATE, title: "date" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.LOCATION, title: "location" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.TIME, title: "time" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.PARTICIPANTS, title: "participants" },
  ],
  [DESIGN_STYLES.NOTIFICATION]: [
    { prop: LAYOUT_STRUCTURE_OPTIONS.TEXT, title: "subtext" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.DATE, title: "date" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.ICON, title: "icon" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.LINK, title: "link-text" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.ARROW, title: "arrow" },
  ],
  [DESIGN_STYLES.IMAGE]: [
    { prop: LAYOUT_STRUCTURE_OPTIONS.DATE, title: "date" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.LOCATION, title: "location" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.PARTICIPANTS, title: "participants" },
    { prop: LAYOUT_STRUCTURE_OPTIONS.DATE_IN_IMAGE, title: "date-in-image" },
  ],
};

export const CONTENT_BASED_ON_DESIGN = {
  [DESIGN_STYLES.BACKGROUND]: [
    {
      prop: ANNOUNCEMENT_PROP.TITLE,
      title: "title",
      type: "input",
      layout: undefined,
    },
    {
      prop: ANNOUNCEMENT_PROP.LINK_TEXT,
      title: "link-text",
      type: "input",
      layout: "link",
    },
    {
      prop: ANNOUNCEMENT_PROP.DATE,
      title: "date",
      type: "date",
      layout: "date",
    },
  ],
  [DESIGN_STYLES.CLASSIC]: [
    {
      prop: ANNOUNCEMENT_PROP.TITLE,
      title: "title",
      type: "input",
      layout: undefined,
    },
    {
      prop: ANNOUNCEMENT_PROP.TEXT,
      title: "subtext",
      type: "textarea",
      layout: "text",
    },
    {
      prop: ANNOUNCEMENT_PROP.LOCATION,
      title: "location",
      type: "input",
      layout: "location",
    },
    {
      prop: ANNOUNCEMENT_PROP.DATE,
      title: "date",
      type: "date",
      layout: "date",
    },
    {
      prop: ANNOUNCEMENT_PROP.TIME,
      title: "time",
      type: "time",
      layout: "time",
    },
  ],
  [DESIGN_STYLES.NOTIFICATION]: [
    {
      prop: ANNOUNCEMENT_PROP.TITLE,
      title: "title",
      type: "input",
      layout: undefined,
    },
    {
      prop: ANNOUNCEMENT_PROP.TEXT,
      title: "subtext",
      type: "textarea",
      layout: "text",
    },
    {
      prop: ANNOUNCEMENT_PROP.DATE,
      title: "date",
      type: "date",
      layout: "date",
    },
    {
      prop: ANNOUNCEMENT_PROP.LINK_TEXT,
      title: "label-text",
      type: "input",
      layout: "link",
    },
  ],
  [DESIGN_STYLES.IMAGE]: [
    {
      prop: ANNOUNCEMENT_PROP.TITLE,
      title: "title",
      type: "input",
      layout: undefined,
    },
    {
      prop: ANNOUNCEMENT_PROP.DATE,
      title: "date",
      type: "date",
      layout: "date",
    },
    {
      prop: ANNOUNCEMENT_PROP.LOCATION,
      title: "location",
      type: "input",
      layout: "location",
    },
  ],
};
